import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";

const useStyles = makeStyles({
  root: {
    width: "93%",
  },
  input: {
    width: 42,
  },
});

export default function InputSlider(props) {
  const { label, handleChange, max, min, iniValue } = props;

  const classes = useStyles();
  const [value, setValue] = React.useState(iniValue);

  const handleSliderChange = (event, newValue) => {
    setValue(newValue);
    handleChange(newValue);
  };

  return (
    <div className={classes.root}>
      <span id="input-slider">{label}</span>
      <Slider
        max={max}
        min={min}
        value={typeof value === "number" ? value : 0}
        onChange={handleSliderChange}
        valueLabelDisplay="auto"
        aria-labelledby="input-slider"
      />
    </div>
  );
}
